var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2602_4898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.333 8H8.33301C6.11301 8 4.35301 9.78 4.35301 12L4.33301 36C4.33301 38.22 6.11301 40 8.33301 40H40.333C42.553 40 44.333 38.22 44.333 36V12C44.333 9.78 42.553 8 40.333 8ZM40.333 36H8.33301V24H40.333V36ZM40.333 16H8.33301V12H40.333V16Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2602_4898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
};
export default SvgCreditCard;